module.exports = __webpack_public_path__ + "static/media/project6.937acfad.jpg";